import { UsersService } from './users/users.service';
import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

import { Subject, Observable, pipe, of, from, Subscription, throwError } from 'rxjs';
import { map, retryWhen, delay, switchMap, retry, catchError } from 'rxjs/operators';

import { WPSID } from 'app/_class/wpsid';
import { Cliente } from 'app/_class/cliente';
import { Point } from 'app/_class/point';
import { Permiso } from 'app/_interfaces/permiso';
import { JsonHc } from 'app/_interfaces/json-hc';
import { Grupo } from 'app/_class/grupo';
import { ResponsePermisoHTTP } from 'app/_interfaces/response-permiso-http';
import { ResponseRecoverEmail } from 'app/_interfaces/response-recover-email';
import { ReverseGeocodingResponseIQ } from 'app/_interfaces/reverse-geocoding-response-iq';

import { Actividad } from 'app/_class/indicadores/actividad';
import { Alerta } from 'app/_class/indicadores/alerta';
import { Rendimiento } from 'app/_class/indicadores/rendimiento';
import { GetClases } from 'app/_class/get-clases';
import { StorageService } from './storage/storage.service';
import { SessionCheckService } from './sesionCheck/sessionCheck.service';
import { CookieService } from 'ngx-cookie-service';
import { environment } from './../../environments/environment';
import { productFruits } from 'product-fruits';
import { AuthService } from 'app/_utils/auth/auth.service';
@Injectable({
  providedIn: 'root'
})
export class LoginService implements OnDestroy {
  $sesion = new Subject<boolean>();
  $idCliente = new Subject<number>();
  $cargarClientes = new Subject<boolean>();
  idCliente = -1;
  $nombreCliente = new Subject<string>();
  nombreCliente = "foo"
  hasSession = false;
  wpsid: WPSID = new WPSID('');
  isInLogin = false;
  cookies = {
    config: {
      domain: 'waypoint.cl',
      path: '/'
    },
    newWebapp: { name: 'newWebapp', value: { active: 'true', inactive: 'false' } },
    idUsr: { name: '0x100', value: '' }
  };
  idUsr: number;
  //permisos: Permiso[];
  //$permiso = new Subject<Permiso[]>();
  usrName = '';
  pass = '';
  refUserName = 'usrName';
  userType = 0;
  // clientes para el usuario actual
  clientes: Cliente[];

  pipelingIndicadores = pipe(
    switchMap(data => of(data)),
    map((data: any) => {
      data = new Rendimiento(data);
      if (!data.isComplete()) {
        console.log('INCOMPLETE');
        return;
      }
      return data;
    }),
  );

  dominio = 'localhost';

  constructor(
    private readonly http: HttpClient,
    private readonly router: Router,
    private readonly usersService: UsersService,
    private readonly storage: StorageService,
    private readonly sessionCheckService: SessionCheckService,
    private readonly cs: CookieService) {
    if (window.location.hostname.endsWith('waypoint.cl')) {
      this.dominio = 'waypoint.cl';
    }
    if (window.location.hostname.endsWith('tranciti.com')) {
      this.dominio = 'tranciti.com';
    }
    /* Escucha en caso de que se ciere la sesion */
    this.$sesion.pipe().subscribe(hasSesion => {
      this.hasSession = hasSesion;
      if (!hasSesion && !this.isInLogin) {
        this.cerrarSesion(true);
      }
    });
  }
  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
  subs : Subscription;

  async activarService() {
    // carga los clientes para el select
    await this.cargarClientes();
    //  actualiza los permisos cuando cambia  el id de Cliente
    this.subs = this.$idCliente.subscribe((idCliente: number) => {
    //  envia datos de user atributes para Hotjar al iniciar sesion y cambiar cliente (user,clientId)
      this.sendToHotjar(idCliente);

      this.idCliente = Number(idCliente);
      /*this.getPermisos(this.idCliente).subscribe((responsePermiso: ResponsePermisoHTTP) => {
        this.permisos = responsePermiso.permisos;
        this.$permiso.next(this.permisos);
      });
      */
    });

    return true;
  }

  loadPf= async (clients) => {
    
    const idFromStorage = +localStorage.getItem("id");
    const dataCore = await this.usersService.getDataCore(idFromStorage);

  
    if (dataCore && dataCore.data) {
      const { idClient, firstName, lastName, email,} = dataCore.data;
      
      // Persistir en localStorage
      localStorage.setItem('idClientUser', idClient ? idClient : 'No encontrado');
      localStorage.setItem('firstName', firstName ? firstName: 'No encontrado');
      localStorage.setItem('lastName', lastName ? lastName : 'No encontrado');
      localStorage.setItem('email', email ? email : 'No encontrado');
  
      // Variables locales
      let nameClientUser = "No encontrado";
      let countryClientUser = "No encontrado";
      let userClient= idClient?  clients.find(item => item.id === idClient) :null;
      nameClientUser = userClient.name ? userClient.name : "No encontrado"; 
      countryClientUser= userClient.countryName ? userClient.countryName: "No encontrado";


      // Persistir también en localStorage
      localStorage.setItem('nameClientUser', nameClientUser);
      localStorage.setItem('countryClientUser', countryClientUser);
      
  
      const user = {
        username: localStorage.getItem("usrName") ? localStorage.getItem("usrName"): "No encontrado",
        firstname: firstName ? firstName : 'No encontrado',
        lastname: lastName ? lastName : 'No encontrado',
        email: email ? email : 'No encontrado',
        props: {
          client: nameClientUser,
          country: countryClientUser,
        }
      };

  
      productFruits.init(environment.fruitsWorkspace, 'es', user);
      productFruits.safeExec($pf => {
        console.log('Product Fruits is ready!');
        console.log("user ", user);
        console.log("$pf.length: ",$pf.length)
      });
    } else {
      console.warn("No se pudo obtener dataCore");
      const user = {
        username: localStorage.getItem("usrName") ? localStorage.getItem("usrName"): "No encontrado",
        firstname: localStorage.getItem("firstName") ? localStorage.getItem("firstName") : 'No encontrado',
        lastname: localStorage.getItem("lastName") ? localStorage.getItem("lastName") : 'No encontrado',
        email: localStorage.getItem("email") ? localStorage.getItem("email") : 'No encontrado'
      };

  
      productFruits.init(environment.fruitsWorkspace, 'es', user);
      productFruits.safeExec($pf => {
        console.log('Product Fruits is ready!');
        console.log("user ", user);
        console.log("$pf.length: ",$pf.length);
      });
    }
  
    console.log("terminado las frutas");
  };

  async cargarClientes() {

    (await this.getClientes()).subscribe(async (response: any) => {
      const content = JSON.stringify(response);

      const parsedData = JSON.parse(content);
      const data = parsedData ? parsedData.data : [];
      if (data.length === 1 && data.error === 'no sesion') {
        await this.cerrarSesion(true);
      }


      if (data.length > 0 && data[0].error === undefined) {

        const arrClient: Cliente[] = data;
        this.clientes = [];
        for (const tmp of arrClient) {
          this.clientes.push(tmp);
        }
        const client = this.storage.get('dash', 'client');
        const clientSelectedId = client ? client : this.clientes[0].id;
        const clientSelectedName = this.clientes.find(e => e.id === clientSelectedId).name;

        this.loadPf(this.clientes);

        this.idCliente = clientSelectedId;
        this.setCookie('idcliente', clientSelectedId);
        this.setCookie('nombreCliente', clientSelectedName)
        this.$idCliente.next(clientSelectedId);
        this.$cargarClientes.next(true);

      } else {
        console.error(content);
        if (content === '[{"error":"no sesion"}]') {
          await this.cerrarSesion(true);
        }
      }
      return true;
    },
      error => {
        console.log(error.error);
      });

    return true;
  }
  // al cerrar sesion con el login nuevo deja esta cookies que despues se usan para redirigirte
  redirectLogout(){
    // Al hacer logout, se checkea si es parte del login nuevo
    // const logout = localStorage.getItem("logout");
    // const goToLogin = this.cs.get('newLogin');
    // if(logout !== undefined && logout === 'true' && goToLogin !== undefined && goToLogin !== null && goToLogin !== ''){
      localStorage.removeItem("logout")
      console.log("newLogin close session by logout");
      const to = `${environment.appLogin}/logout`
      window.location.href = to;
      return;
    // }
  }

  isSessionValid(origen){
    return this.sessionCheckService.isSessionValid(origen)
  }
  /**
   *  Recovery the value of  cookie wpsid and  set the value  to  {thishasSession}
   *
   * Return true if the cookie is not empty or  else false
   *
   *
   * @returns boolean
   */
  recoverSession(): boolean {
    console.log("recovering session");
    if (this.wpsid === undefined) {
      this.wpsid = new WPSID('');
    }
    const recoveryValue = this.cs.get('wpsid')
    if (recoveryValue !== undefined) {
      this.wpsid.value = recoveryValue;
    }
    if (this.usrName === undefined) {
      this.usrName = this.getCookie(this.refUserName);
    }

    const idTemp = parseInt(this.getCookie(this.cookies.idUsr.name), 10);
    if (!isNaN(idTemp)) {
      this.idUsr = idTemp;
    }

    this.hasSession = this.wpsid.value && this.wpsid.value.length > 5;
    console.log("thish", this.hasSession);
    return this.hasSession;
  }

  obtenerCognito(cognito): boolean {
    let cgn = false;
    const paramName = 'AuthenticationResult';
    console.log("cognito: ", cognito);

    if (typeof cognito !== 'number') {
      try { // obtener cognito
        if (typeof cognito === 'object' && typeof cognito[paramName].IdToken === 'string') {
          const token = cognito[paramName].AccessToken;
          //Se almacena el refreshToken (Motivo de esto es para poder usarlo en lastmile para renovacion de token para servicios utilizados alla)
          const refreshToken = cognito[paramName].RefreshToken;
          console.log(token);
          localStorage.setItem("crossToken", token)
          this.setCookie('at', token);
          this.setCookie('rt', refreshToken);
          cgn = true;
        }
      } catch (e) {
        console.log(e);
      }
    }
    return cgn;
  }

  getInfoToken(token: string) {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  
    return JSON.parse(jsonPayload);
  }

  // crea la Sesion
  logIn(usr: string, pas: string) {
    this.isInLogin = true;
    this.usrName = usr;
    this.pass = pas;
    this.loginTomcat().subscribe(
      response => {
        const cgn = this.obtenerCognito(response.body);
        if (cgn || response.body === 5) {
          const userInfo = response.body["AuthenticationResult"].IdToken;

          const infoDec = this.getInfoToken(userInfo);
          this.idUsr = infoDec["custom:id"]

          this.hasSession = true;
          const wp = response.headers.get('wpsid');
          this.wpsid = new WPSID(wp);
          this.saveUser(wp, this.idUsr);
          localStorage.setItem('wpsid', this.wpsid.value);
          localStorage.setItem('id', this.idUsr + '');
          localStorage.setItem('usrName', this.usrName);
          // if(LoginService.LIST_USERS.includes(this.idUsr)){
          //   this.setCookie('newLogin', true);
          // }
          this.setCookie('wpsid', this.wpsid.value);
          this.setCookie('usrName', usr);
          this.setCookie(this.cookies.newWebapp.name, this.cookies.newWebapp.value.active);
          this.setCookie(this.cookies.idUsr.name, this.idUsr);
          this.setCookie('JSESSIONID', this.wpsid.value);

          const navbar = document.createElement('tranciti-navbar');
          document.body.insertBefore(navbar, document.body.firstChild);

          this.$sesion.next(true);
        } else {
          console.error('No se pudo validar el id de usuario: ' + this.usrName);
          this.$sesion.next(false);
        }

        this.isInLogin = false;
      },
      err => {
        console.log('HTTP ERROR 1 ' + err);
        this.$sesion.next(false);
        this.isInLogin = false;
      }
    );

    return this.$sesion.asObservable();
  }

  async saveUser(wpsid: string, idp: number) {
    const data = await this.usersService.getData(wpsid, idp);
    console.log("DATA", data);
    if (data && data.usuario) {
      const { nombre, apellido, id,correo } = data.usuario;
      let { tipo } = data.usuario;
      tipo = tipo && tipo !== undefined ? tipo : 0;
      localStorage.setItem('name', `${nombre} ${apellido}`);
      localStorage.setItem('type', tipo);
      localStorage.setItem('id', id + '');
      localStorage.setItem('firstName', nombre + '');
      localStorage.setItem('lastName', apellido + '');
      localStorage.setItem('email', correo + '');
    }
  }

  loginTomcat() {
    const url = `${environment.endPoint}/WaypointSessions/OpenSessionAsync`;
    console.log(`Url de sesion: ${url}`);

    const body = {
      usuario: this.usrName,
      pass: this.pass,
      dom: this.dominio
    };

    return this.http.post(url, body, { observe: 'response' });
  }

  public setCookie(name, value) {
    const d = new Date();
    d.setTime(d.getTime() + (7 * 24 * 60 * 60 * 1000));
    localStorage.setItem(name, value);

    if (this.dominio === 'localhost') {
      this.cs.set(name, value, d, '/', this.dominio, false, 'Strict');
    } else {
      this.cs.set(name, value, d, '/', this.dominio, true, 'Strict');
    }

  }

  private deleteCookie(name: string) {
    this.cs.delete(name);
  }

  private getCookie(cname) {
    return (document.cookie.match(`(^|;) *${cname}=([^;]*)`) || '')[2];
  }

  // obtiene  la lista de clientes por  usuario
  async getClientes() {
    let at = await AuthService.getAt();
    while (at === null || at === undefined) {
      await new Promise(resolve => setTimeout(resolve, 1000));
      at = await AuthService.getAt();
    }
    const url = `${environment.endPoint}/ClientSite/api/GetUserClients`;
    const httpOptions = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json;charset=utf-8')
        .set('Authorization', `Bearer ${at}`)
    };
    return this.http.get(url, httpOptions);
  }

  forgotPasswordAutomatic(user) {
    const formData: FormData = new FormData();
    formData.append('info', user);

    const httpOptions = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
    };
    // TO-DO: AÑADIR RECUPERACIÓN DE PASSWORD CUANDO EL ENDPOINT ESTÉ DISPONIBLE
  }
  stopSessionCheck(){
    this.sessionCheckService.detenerMonitoreo("cerrarSesion")
  }
  // Cierra la Sesion
  async cerrarSesion(redirect: boolean) {
    console.warn('__CERRANDO_SESSION__');
    document.querySelectorAll('tranciti-navbar').forEach(el => el.remove());
    const controllerWP = new AbortController();

    const signalWP = controllerWP.signal;
    setTimeout(() => {
      controllerWP.abort();
    },5000)
    // Sesión de WaypointSessions
    const logoutWpSessions = `${environment.endPoint}/WaypointSessions/CloseSession?to=`; //el "to" vacío hace que no redirija
    await fetch(logoutWpSessions, {
      method: "GET",
      credentials: "include" as RequestCredentials,
      redirect: "manual" as RequestRedirect, //si cambia el comportamiento del "to" igualmente no queremos redirigir
      signal: signalWP
    }).then(data => {
      console.log( data.text() );
      console.log('Session WaypointSession: closed')
    }).catch(() => console.error('Session WaypointSession: process error'));
    
    // SOP-8916: ya no existe sesion PHP legacy (logoff.php retirado por PHP2Shell)
    // Borrado de cookies y redirect
    this.stopSessionCheck()
    this.borrarDatosDeSesion()
    this.usrName = undefined;

    this.redirectLogout();
    
    // if(LoginService.LIST_USERS.includes(this.idUsr)){
    //   this.setCookie('newLogin', true);
    //   localStorage.setItem("logout",'true');
    //   this.redirectLogout();
    // } else{
    //   this.router.navigate(['login']);
    // }
  }

  borrarDatosDeSesion(){
    // borra las cookies
    this.cs.deleteAll('/', this.dominio);
    // borra los datos de local storage
    Object.keys(localStorage).forEach(key => {
        if (!key.startsWith('comp') && !key.startsWith('allFilters')) {
            localStorage.removeItem(key);
        }
    })
  }

  // Obtiene la lista  de vehiculos por cliente

  /*getVehiculos(idCliente: number): Observable<JsonHc> {
    return this.http.get<JsonHc>(`${environment.endPoint}/Req/GetJsonHC?idcliente=${this.idCliente}&${this.wpsid.getUrlEncode()}`);
  }*/

  /*getGrupos(idCliente: number): Observable<Grupo[]> {
    const url = `${environment.endPoint}/Req/GetGrupo?id_cliente=${idCliente}&${this.wpsid.getUrlEncode()}`;

    return this.http.get<Grupo[]>(url);

  }*/

  // obtiene esquema de permnisos
  /*getPermisos(idCliente: number) {/// TO DO
    const url = environment.endpointPermisos;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    const request: any = {};
    request.wpsid = this.wpsid.value;
    request.idCliente = idCliente.toString();
    request.usuario = this.usrName.toString();
    return this.http.post<ResponsePermisoHTTP>(url, request, httpOptions);
  }*/

  /**
   * Obtiene la direccion dada  unas coordenadas lat,lng
   *
   * @param Point point
   * @returns Observable<ReverseGeocodingResponseIQ>
   */
  getDireccion(point: Point): Observable<ReverseGeocodingResponseIQ> {
    let hostname: string
    try{
      hostname = window.location.href
      hostname = encodeURIComponent(hostname)
    } catch(e) {
      hostname = 'sin_especificar_webapp'
    }

    const url = `${environment.locationIQ.endPointReverseGeocoding}?info=detailed&lat=${point.lat}&lon=${point.lng}&project=${hostname}`;
    return this.http.get<ReverseGeocodingResponseIQ>(url);
  }

  recuperarContrasenia(email: string) {
    return;
    // TO-DO: AÑADIR RECUPERACIÓN DE PASSWORD CUANDO EL ENDPOINT ESTÉ DISPONIBLE
  }


  // Operaciones para el Api EndPoint


  getUserId() {
    const id = localStorage.getItem('id');
    return id && id !== undefined ? id : 0;
  }

  getIndicadorAlerta(groups: number[], fleets: number[], vehicles: number[]) {
    const url = `${environment.apiEndPoint}/alertas?`;
    const params = `idCliente=${this.idCliente}&grupos=${groups.join(',')}&flotas=${fleets.join(',')}&vehiculos=${vehicles.join(',')}`;
    return from(AuthService.getAt()).pipe(
      switchMap(at => {
        const httpOptions = {
          headers: new HttpHeaders()
            .set('Content-Type', 'application/json;charset=utf-8')
            .set('Authorization', `Bearer ${at}`)
        };
        return this.http.get<Alerta>(`${url}${params}`, httpOptions);
      }),
      this.pipelingIndicadores,
      retry(3),
      catchError(err => this.errorHandler(err))
    );
  }

  getIndicadorActividad(groups: number[], fleets: number[], vehicles: number[]) {
    // disabled, see PLAT-239
    return;
    const url = `${environment.apiEndPoint}/actividad?`;
    const params = `idCliente=${this.idCliente}&grupos=${groups.join(',')}&flotas=${fleets.join(',')}&vehiculos=${vehicles.join(',')}`;
    return from(AuthService.getAt()).pipe(
      switchMap(at => {
        const httpOptions = {
          headers: new HttpHeaders()
            .set('Content-Type', 'application/json;charset=utf-8')
            .set('Authorization', `Bearer ${at}`)
        };
        return this.http.get<Actividad>(`${url}${params}`, httpOptions);
      }),
      this.pipelingIndicadores,
      retry(3),
      catchError(err => this.errorHandler(err))
    );
  }


  getClasesVeviculo(idCliente: number = -1): Observable<GetClases> {
    let aux = "";
    if (idCliente > 0) {
      aux = `&idcliente=${idCliente}&opt=porCliente`;
    }
    const url = `${environment.endPoint}/WebappAdmin/GetClases?${this.wpsid.getUrlEncode()}${aux}`;
    

    return this.http.get<GetClases>(url).pipe(
      retry(3),
      catchError(err => this.errorHandler(err))
    );
  }

  sendToHotjar(idCliente) {
    // hotjar integración
    const hj = (window as any).hj;
    hj('identify', this.usrName, {
      // Add your own custom attributes here.
      'report_id': null,
      'report_name': null,
      'client_id': idCliente,

    });

  }

  errorHandler = (error: HttpErrorResponse) => {
    let errorMsg = '';
    if (error.error instanceof ErrorEvent) {
        console.log('getpoints: error del lado del cliente');
        errorMsg = `Error: ${error.error.message}`;
    } else {
        errorMsg = `Código de error: ${error.status}, Mensaje: ${error.message}`
    }
    console.error(errorMsg);
    return throwError(errorMsg)
  }

}
type PfWindow = {
  productFruits: any;
}